<template>
  <div class="otherfooterwite-style">
    <div class="footer-topmain">
      <div class="footer-topcontent">
 
        <div class="footer-content">
   
          <div id="amap-container" class="map-style"></div>
          <div>
            <div class="homefooter-right">
              <span>
                <svg
                  width="16"
                  height="12"
                  viewBox="0 0 16 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  v-if="name == 'home'"
                >
                  <g opacity="0.5">
                    <mask id="path-1-inside-1_129_2345" fill="white">
                      <rect width="16" height="11.5556" rx="1" />
                    </mask>
                    <rect
                      width="16"
                      height="11.5556"
                      rx="1"
                      stroke="white"
                      stroke-width="3"
                      mask="url(#path-1-inside-1_129_2345)"
                    />
                    <path
                      d="M0.888672 1.77783L7.10536 4.88617C7.66841 5.1677 8.33116 5.1677 8.89421 4.88617L15.1109 1.77783"
                      stroke="white"
                      stroke-width="1.5"
                    />
                  </g>
                </svg>
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="12"
                  viewBox="0 0 16 12"
                  fill="none"
                >
                  <mask id="path-1-inside-1_101_194" fill="white">
                    <rect width="16" height="11.5556" rx="1" />
                  </mask>
                  <rect
                    width="16"
                    height="11.5556"
                    rx="1"
                    stroke="#999999"
                    stroke-width="3"
                    mask="url(#path-1-inside-1_101_194)"
                  />
                  <path
                    d="M0.888672 1.77783L7.10536 4.88617C7.66841 5.1677 8.33116 5.1677 8.89421 4.88617L15.1109 1.77783"
                    stroke="#999999"
                    stroke-width="1.5"
                  />
                </svg>
                <span class="righttext">官方邮箱</span></span
              >
              <span class="contactustext">business@graphchain.top</span>
            </div>
            <div class="homefooter-right">
              <span>
                <svg
                  v-if="name == 'home'"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.5">
                    <circle
                      cx="8"
                      cy="8"
                      r="7.25"
                      stroke="white"
                      stroke-width="1.5"
                    />
                    <path
                      d="M7.11133 3.55554V8.88888H11.5558"
                      stroke="white"
                      stroke-width="1.5"
                    />
                  </g>
                </svg>
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <circle
                    cx="8"
                    cy="8"
                    r="7.25"
                    stroke="#999999"
                    stroke-width="1.5"
                  />
                  <path
                    d="M7.11133 3.55554V8.88888H11.5558"
                    stroke="#999999"
                    stroke-width="1.5"
                  />
                </svg>
                <span class="righttext">工作时间</span></span
              >
              <span class="contactustext">周一至周五 9:30 - 18:30</span>
            </div>
            <div class="homefooter-right">
              <span class="map-styleright"
                ><svg
                  v-if="name == 'home'"
                  width="23"
                  height="22"
                  viewBox="0 0 23 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.5">
                    <path
                      d="M7.3124 6.27766C9.69673 4.14471 13.3033 4.14471 15.6876 6.27766C18.201 8.52608 18.4902 12.3581 16.3428 14.9583L11.5 20.8222L6.65719 14.9583C4.50977 12.3581 4.79901 8.52608 7.3124 6.27766Z"
                      stroke="white"
                      stroke-width="1.5"
                    />
                    <path
                      d="M12.9442 11.0605C12.9442 11.8505 12.3037 12.491 11.5136 12.491C10.7235 12.491 10.083 11.8505 10.083 11.0605C10.083 10.2704 10.7235 9.62988 11.5136 9.62988C12.3037 9.62988 12.9442 10.2704 12.9442 11.0605Z"
                      fill="white"
                    />
                  </g>
                </svg>
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  width="23"
                  height="22"
                  viewBox="0 0 23 22"
                  fill="none"
                >
                  <path
                    d="M7.3124 6.27766C9.69673 4.14471 13.3033 4.14471 15.6876 6.27766C18.201 8.52608 18.4902 12.3581 16.3428 14.9583L11.5 20.8222L6.65719 14.9583C4.50977 12.3581 4.79901 8.52608 7.3124 6.27766Z"
                    stroke="#999999"
                    stroke-width="1.5"
                  />
                  <path
                    d="M12.9442 11.0602C12.9442 11.8503 12.3037 12.4908 11.5136 12.4908C10.7235 12.4908 10.083 11.8503 10.083 11.0602C10.083 10.2701 10.7235 9.62964 11.5136 9.62964C12.3037 9.62964 12.9442 10.2701 12.9442 11.0602Z"
                    fill="#999999"
                  />
                </svg>
                公司总部
              </span>
              <span class="contactustext">
                成都市武侯区交子大道中海国际D座4-8楼</span
              >
            </div>
            <div class="homefooter-right">
              <span>
                <svg
                  v-if="name == 'home'"
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.5">
                    <path
                      d="M0.75 7.5C0.75 3.77208 3.77208 0.75 7.5 0.75C11.2279 0.75 14.25 3.77208 14.25 7.5V14.25H7.5C3.77208 14.25 0.75 11.2279 0.75 7.5Z"
                      stroke="white"
                      stroke-width="1.5"
                    />
                    <circle cx="4" cy="8" r="1" fill="white" />
                    <circle cx="7.5" cy="8" r="1" fill="white" />
                    <circle cx="11" cy="8" r="1" fill="white" />
                  </g>
                </svg>
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                >
                  <path
                    d="M0.75 7.5C0.75 3.77208 3.77208 0.75 7.5 0.75C11.2279 0.75 14.25 3.77208 14.25 7.5V14.25H7.5C3.77208 14.25 0.75 11.2279 0.75 7.5Z"
                    stroke="#999999"
                    stroke-width="1.5"
                  />
                  <circle cx="4" cy="8" r="1" fill="#999999" />
                  <circle cx="7.5" cy="8" r="1" fill="#999999" />
                  <circle cx="11" cy="8" r="1" fill="#999999" />
                </svg>
                <span class="righttext">客服微信</span>
              </span>
              <img src="../assets/image/homePage/mainbottom/weixinimg.png" alt="" />
            </div>
            <div class="homefooter-right">
              <a href="https://graphchain.feishu.cn/share/base/form/shrcnwy8omau58IAfPyF8jSIL2d?ccm_open_type=form_v2_link_share" target="_blank"> 
              <el-button type="primary" class="footer-button">
                联系我们
                  </el-button></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-line"></div>

    <div class="footer-bottom">
      <div class="footer-bottomleft">
        <span class="bottomleft-logo">

          <svg xmlns="http://www.w3.org/2000/svg" width="43" height="48" viewBox="0 0 43 48" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M21.8411 0.726562L0 10.752V36.8898L21.8411 47.2732L42.6081 36.8898V10.752L21.8411 0.726562ZM13.2483 17.1971L27.2123 10.036L21.6141 7.88772L8.23556 14.6907L7.8775 33.3094L22.0689 40.4272L35.4474 33.3094V14.2476L21.6141 21.3937V27.5805L30.4347 23.2489V30.4938L21.6141 34.7847L12.8902 30.4938L13.2483 17.1971Z" fill="url(#paint0_linear_515_47)"/>
  <path opacity="0.3" d="M0 10.5593L21.4831 20.9525V47.0806L0 36.6874V10.5593Z" fill="url(#paint1_linear_515_47)"/>
  <path opacity="0.2" d="M42.6084 10.5688L21.4834 20.9523V47.0804L42.6084 36.6969V10.5688Z" fill="url(#paint2_linear_515_47)"/>
  <defs>
    <linearGradient id="paint0_linear_515_47" x1="33.6568" y1="7.52954" x2="21.304" y2="47.2732" gradientUnits="userSpaceOnUse">
      <stop stop-color="#02C7F6"/>
      <stop offset="1" stop-color="#0877FF"/>
    </linearGradient>
    <linearGradient id="paint1_linear_515_47" x1="10.7415" y1="10.5593" x2="10.7415" y2="35.6229" gradientUnits="userSpaceOnUse">
      <stop/>
      <stop offset="1" stop-color="#030303" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint2_linear_515_47" x1="32.0459" y1="10.5688" x2="32.0459" y2="35.6258" gradientUnits="userSpaceOnUse">
      <stop/>
      <stop offset="1" stop-color="#030303" stop-opacity="0"/>
    </linearGradient>
  </defs>
</svg>
          <span></span>
          <svg width="156" height="22" viewBox="0 0 156 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.232665 0.961024H10.8489C12.1457 0.961024 13.273 1.10088 14.2308 1.38059C15.197 1.65182 15.998 2.029 16.6337 2.51213C17.2694 2.99526 17.7398 3.57163 18.045 4.24124C18.3586 4.90236 18.5154 5.61859 18.5154 6.3899C18.5154 7.65283 18.117 8.75894 17.3203 9.70826C18.2357 10.2507 18.918 10.9542 19.3672 11.8188C19.8165 12.6833 20.0411 13.6665 20.0411 14.7684C20.0411 15.6923 19.8843 16.5272 19.5707 17.2731C19.2655 18.019 18.7951 18.6589 18.1594 19.1929C17.5322 19.7184 16.7354 20.1253 15.7692 20.4134C14.8114 20.6932 13.6798 20.833 12.3745 20.833H0.232665V0.961024ZM12.4 8.58942C12.7475 8.58942 13.0865 8.60214 13.4171 8.62757C13.985 8.0851 14.2689 7.46635 14.2689 6.77132C14.2689 6.05086 13.985 5.49568 13.4171 5.10579C12.8577 4.70742 12.0355 4.50823 10.9506 4.50823H4.263V8.58942H12.4ZM12.4762 17.3239C13.5612 17.3239 14.3833 17.0909 14.9428 16.6247C15.5107 16.1585 15.7946 15.5016 15.7946 14.654C15.7946 13.8064 15.5107 13.1453 14.9428 12.6706C14.3833 12.196 13.5612 11.9586 12.4762 11.9586H4.263V17.3239H12.4762ZM26.869 0.961024H43.7913V4.49552H30.8993V8.46228H42.3165V11.7806H30.8993V17.3112H44.0583V20.833H26.869V0.961024ZM50.7591 0.961024H54.8149V20.833H50.7591V0.961024ZM62.7108 0.961024H66.7411L73.9627 8.208L81.1842 0.961024H85.2146V20.833H81.1842V6.54247L73.9627 13.497L66.7411 6.54247V20.833H62.7108V0.961024ZM93.0978 0.961024H97.1535V20.833H93.0978V0.961024ZM105.011 0.961024H109.042L121.425 7.44516V0.961024H125.455V20.833H121.425V11.7171L109.042 5.27107V20.833H105.011V0.961024ZM132.449 10.7127C132.449 9.31412 132.711 8.00882 133.237 6.79675C133.762 5.57621 134.529 4.51671 135.538 3.61825C136.547 2.71979 137.784 2.01205 139.251 1.49501C140.725 0.977976 142.412 0.719458 144.311 0.719458C144.997 0.719458 145.684 0.7576 146.37 0.833884C147.065 0.901692 147.748 1.01188 148.417 1.16445C149.095 1.31702 149.752 1.51196 150.388 1.74929C151.032 1.97814 151.643 2.25361 152.219 2.5757L150.363 5.62706C150.015 5.42364 149.621 5.2414 149.18 5.08036C148.739 4.91084 148.265 4.77099 147.756 4.6608C147.256 4.54213 146.735 4.45314 146.192 4.3938C145.658 4.33447 145.12 4.30481 144.578 4.30481C143.323 4.30481 142.204 4.46585 141.221 4.78794C140.238 5.10155 139.407 5.54654 138.729 6.12291C138.051 6.6908 137.534 7.37312 137.178 8.16986C136.822 8.96661 136.644 9.83963 136.644 10.7889C136.644 11.7722 136.831 12.6749 137.204 13.497C137.577 14.3192 138.106 15.0269 138.793 15.6203C139.479 16.2136 140.31 16.6798 141.285 17.0188C142.26 17.3494 143.349 17.5147 144.552 17.5147C145.51 17.5147 146.387 17.4087 147.184 17.1968C147.981 16.9764 148.676 16.6671 149.269 16.2687C149.863 15.8703 150.346 15.3914 150.719 14.832C151.092 14.2641 151.337 13.6284 151.456 12.9249H144.514V9.60654H155.08V9.61926L155.092 9.60654C155.304 10.6237 155.368 11.6154 155.283 12.5816C155.207 13.5394 154.986 14.4463 154.622 15.3024C154.266 16.15 153.774 16.9298 153.147 17.6418C152.52 18.3538 151.77 18.9683 150.897 19.4853C150.024 19.9939 149.032 20.3923 147.922 20.6804C146.811 20.9601 145.595 21.1 144.273 21.1C142.425 21.1 140.768 20.8288 139.301 20.2863C137.844 19.7438 136.606 19.0022 135.589 18.0614C134.572 17.1205 133.792 16.0186 133.25 14.7557C132.716 13.4928 132.449 12.1451 132.449 10.7127Z" fill="#333333"/>
</svg>


        </span>
        <span>
          成都北鸣科技有限公司<br />
          备案编号：蜀ICP备2023003901号
        </span>
      </div>
      <div class="footer-bottomright">
        <div>
          <b>成都北鸣</b>
          <span><router-link to="/product">产品服务</router-link></span>
          <span
            ><router-link to="/businessintroduce">业务介绍</router-link></span
          >
          <span> <router-link to="/aboutus">关于我们</router-link></span>
          <!-- <span>隐私政策</span> -->
        </div>
        <div>
          <b>联系我们</b>
          <span
            @mouseover="mouseoverbtn"
            @mouseout="mouseoutbtn"
            class="footer-mainimage"
          >
            <span> 微信 </span>

            <span class="footer-img" v-show="isimage">
              <img src="@/assets/image/homePage/mainbottom/weixinimg.png" alt="" />
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["name"],
  data() {
    return {
      connectionlist: {
        name: "",
        region: "",
        type: "",
      },
      isimage: false,
    };
  },
  mounted() {
    console.log(this.name);
    this.initAMap();
  },
  methods: {
    mouseoverbtn() {
      this.isimage = true;
    },
    mouseoutbtn() {
      this.isimage = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    initAMap() {
      // 高德地图API加载完成后执行初始化
      this.$nextTick(() => {
        var map = new AMap.Map("amap-container", {
          zoom: 13, // 设置地图缩放级别
          center: [104.056544, 30.582004], // 设置地图中心点
        });
        //  navigator.geolocation.getCurrentPosition(
        // (position) => {
        //   console.log(position);
        // const latitude = position.coords.latitude;
        // const longitude = position.coords.longitude;
        // const currentPosition = [longitude, latitude];
        var marker = new AMap.Marker({
          position: [104.056544, 30.582004], // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          title: " 成都市武侯区交子大道中海国际D座4-8楼",

          label: {
            offset: new AMap.Pixel(30, 30), //修改label相对于maker的位置
            content: " 成都市武侯区交子大道中海国际D座4-8楼",
          },
        });
        map.add(marker);
        marker.on("click", function (e) {
          marker.markOnAMAP({
            name: " 成都市武侯区交子大道中海国际D座4-8楼",
            position: marker.getPosition(),
          });
        });

        // 移动地图中心到当前位置
        //   map.setCenter(currentPosition);
        // },
        //     (error) => {
        // if (error.code === error.PERMISSION_DENIED) {
        //   // 用户拒绝了地理位置权限
        //   alert("请授予地理位置权限以使用该功能。");
        // } else {
        //   // 其他错误，处理方式
        // }}
        //   );

        // 添加地图控件，如缩放控件
        // AMap.plugin(["AMap.ToolBar"], function () {
        //   var toolbar = new AMap.ToolBar();
        //   map.addControl(toolbar);
        // });
      });
    },
  },
};
</script>
<style lang="scss">
@import "../assets/scss/otherfooter.scss";
</style>
